<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-4 px-0">
      <nav
        (click)="handleBackNavigation()"
        class="navbar sticky-top main-nav px-3"
      >
        <span
          class="back-button f-18 border-0 primary-font-bold mb-4"
          aria-label="Back navigation"
        >
          <img src="/assets/icons/back-btn.svg" alt="back" class="mr-2" />
          Online payment
        </span>
      </nav>

      <form
        [formGroup]="emailForm"
        (ngSubmit)="collectEmail()"
        class="page-content px-3 py-4"
      >
        <p class="primary-font-normal mb-4">
          To pay online, please enter your email address below and tap the
          proceed button.
        </p>

        <div class="form-group mb-5">
          <label for="email" class="primary-font-medium">Email address</label>
          <input
            class="form-control auth-input"
            type="email"
            formControlName="email"
            placeholder="customer@example.com"
            required
          />
        </div>

        <button
          [disabled]="emailForm.invalid || isProcessingPayment"
          type="submit"
          class="btn py-2 btn-dark btn-block f-14 primary-font-normal"
        >
          <span *ngIf="!isProcessingPayment">Proceed to payment</span>
          <span *ngIf="isProcessingPayment">Processing…</span>
        </button>
      </form>
    </div>
  </div>
</div>
